module.exports = __webpack_public_path__ + "static/media/intro.94f40982.mp4";